export default __webpack_public_path__ + "static/media/lake.52f6cf51.svg";